import {
  IconCookie,
  IconGauge,
  IconClock,
  IconBell,
  IconUsers,
  IconMessage,
  IconLicense,
  IconUserCircle,
  IconUserSearch,
  IconCalendarTime,
  IconFileAnalytics,
  IconClipboardList,
} from "@tabler/icons";
import {
  Card,
  Container,
  SimpleGrid,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import classes from "../styles/FeaturesCards.module.css";

const mockdata = [
  {
    title: "יומן חכם",
    description:
      "ניהול יומן פגישות מתקדם המאפשר תזמון חכם של פגישות, התראות אוטומטיות, וסנכרון עם לוחות שנה חיצוניים לניהול זמן יעיל יותר",
    icon: IconClock,
  },
  {
    title: "מיתוג ועיצוב דף העסק",
    description:
      "אפשרות להתאמה אישית של העיצוב והמיתוג של דף העסק שלך, כולל לוגו, צבעים, מוצרים, וכל פרטי העסק שלכם שיתאימו לזהות המותג שלך",
    icon: IconGauge,
  },
  {
    title: "קביעת תורים ותזכורות",
    description:
      "מערכת מתקדמת לניהול תורים הכוללת אפשרות לקביעת תורים אוטומטית, שליחת תזכורות, וניהול רשימת המתנה",
    icon: IconBell,
    readMore: "/blog/improve-appointment-show-rates-with-reminders",
  },
  {
    title: "דירוג לקוחות וסטטיסטיקה",
    description:
      "כלים לניתוח וסטטיסטיקה של פעילות הלקוחות, כולל דירוג שביעות רצון, היסטוריית ביקורים, והתנהגות צרכנית",
    icon: IconFileAnalytics,
  },
  {
    title: "ניהול תורים גמיש",
    description:
      "אפשרו ללקוחות לבצע ביטול או שינוי התור שלהם בלחיצת כפתור, כולל הודעה מיידית המעדכנת את הלקוח ברגע שתור מתבטל, מתעדכן או נקבע מחדש",
    icon: IconCalendarTime,
  },
  {
    title: "אוטומציית קביעת תורים אוטומטית",
    description:
      "מערכת חכמה המאפשרת ללקוחות לקבוע תורים באופן אוטומטי, עם אופציה לאפשר לקבוע תור ללקוחות קבועים שלכם באופן עצמאי לחלוטין, המערכת לומדת את הלקוחות, ואז באפשרותכם להגדיר זמנים לכל לקוח באופן אישי שיקבע לו התור",
    icon: IconCookie,
  },
  {
    title: "תזכורות WhatsApp ללא הגבלה",
    description:
      "תזכורות אוטומטיות ועדכוני סטטוס על תורים בוואטסאפ ללא הגבלה, ואפשרות לתקשורת דו-כיוונית עם הלקוחות.",
    icon: IconMessage,
  },
  {
    title: "רשימת המתנה",
    description:
      "ניהול יעיל של רשימת המתנה דיגיטלית, המאפשרת ללקוחות להירשם לתורים פנויים ומתן עדיפות על בסיס זמן ההמתנה",
    icon: IconUserCircle,
  },
  {
    title: "סליקת אשראי וקבלות",
    description:
      "מערכת סליקה מאובטחת המאפשרת קבלת תשלומים מלקוחות במעמד קביעת התור, או בקשות תשלום ללקוחות ספציפיים בלבד לפי העדפה שלכם, באמצעות כרטיס אשראי / ביט/אפל פיי/גוגל פיי. כולל אפשרות לחיוב אוטומטי ושמירת פרטי תשלום בעתיד. בסיום התור מיד תתקבל הנפקת קבלה כחוק ללקוח.",
    icon: IconLicense,
  },
  {
    title: "ניהול עובדים ללא הגבלה",
    description:
      "ניהול צוות העובדים ללא הגבלת משתמשים, כולל הרשאות גישה מותאמות, מעקב אחר ביצועים, וניהול משמרות",
    icon: IconUsers,
  },
  {
    title: "גישה מלאה ללא הגבלה",
    description:
      "גישה מלאה לכל תכונות המערכת ללא הגבלה, כולל דוחות מתקדמים, כלי ניהול, ואפשרויות התאמה אישית",
    icon: IconUserSearch,
  },
  {
    title: "טפסים דיגיטליים וחתימה",
    description:
      "בנו טפסים מותאמים אישית (הצהרות בריאות, שאלוני קבלה) עם חתימה דיגיטלית מובנית, שדות חובה, שאלות אמריקאיות ובחירה מרובה. הפיצ'ר הכי מטורף: מעתיקים את הטקסט מהטופס הקיים, מדביקים, והטופס נבנה אוטומטית!",
    icon: IconClipboardList,
  },
];

export function FeaturesCards() {
  const theme = useMantineTheme();
  const features = mockdata.map((feature) => (
    <Card
      key={feature.title}
      shadow="md"
      
      radius="md"
      className={classes.card}
      padding="xl"
    >
      <feature.icon size={40} stroke={2} color={"#667eea"} />
      <Title order={4} fz="lg" fw={500} style={{fontFamily: "rubik"}} className={classes.cardTitle} mt="md">
        {feature.title}
      </Title>
      <Text  fz="sm"  mt="sm" style={{fontFamily: "rubik"}}>
        {feature.description}
      </Text>
      {feature.readMore && (
        <Text component="a" href={feature.readMore} fz="sm" c="blue" fw={600} mt="sm" style={{fontFamily: "rubik"}}>
          קרא/י עוד
        </Text>
      )}
    </Card>
  ));

  return (
    <Container size="lg" py="xl">
      <Title style={{fontFamily: "rubik", fontWeight: "bold"}} order={2} className={classes.title} ta="center" mt="sm">
       כל מה שקליניקה ועסק ביוטי צריכים במקום אחד
      </Title>

      <Title
        order={5}
        style={{fontFamily: "rubik"}}
        className={classes.description}
        ta="center"
        mt="md"
      >
        דאגנו לכל הפרטים הקטנים בניהול התורים שהכל יתנהל עבורכם ב-{" "}
        <span >Quick</span> 😉
      </Title>

      <SimpleGrid cols={{ base: 1, md: 3 }} spacing="lg" mt={40}>
        {features}
      </SimpleGrid>
    </Container>
  );
}
